var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Illustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 383,
    viewBox: "0 0 481 383",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_137259)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M207.577 30.957C205.961 15.5777 217.118 1.79998 232.497 0.183555C247.876 -1.43287 261.654 9.72411 263.27 25.1034L265.57 46.9829L209.877 52.8364L207.577 30.957Z",
    fill: "#7974E0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_246_137259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.84 64.1885L308.073 49.5545C307.784 46.8082 305.324 44.8159 302.578 45.1045L270.256 48.5017C268.883 48.646 267.652 47.6499 267.508 46.2767C267.364 44.9036 266.134 43.9074 264.76 44.0517L210.062 49.8008C208.689 49.9451 207.692 51.1753 207.837 52.5484C207.981 53.9216 206.985 55.1517 205.612 55.296L173.29 58.6932C170.544 58.9819 168.551 61.4422 168.84 64.1885Z",
    fill: "#DEDDFA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_246_137259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.84 64.1883L203.648 60.5298L221.052 58.7005L228.511 57.9166L228.988 57.328C229.822 56.2974 231.032 55.6406 232.351 55.502L244.144 54.2625C245.463 54.1239 246.783 54.5148 247.813 55.3494L248.402 55.826L255.861 55.042L273.265 53.2128L308.073 49.5543C308.362 52.3006 306.369 54.7609 303.623 55.0495L271.301 58.4467C269.928 58.591 268.932 59.8212 269.076 61.1943C269.22 62.5675 268.224 63.7976 266.851 63.942L212.152 69.691C210.779 69.8353 209.549 68.8392 209.405 67.466C209.26 66.0929 208.03 65.0967 206.657 65.2411L174.335 68.6382C171.589 68.9269 169.129 66.9346 168.84 64.1883Z",
    fill: "#B8B5EF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.255 64.6437C236.227 64.3691 236.426 64.1231 236.7 64.0942L241.673 63.5716C241.948 63.5427 242.194 63.7419 242.223 64.0166C242.251 64.2912 242.052 64.5372 241.778 64.5661L239.291 64.8274L238.545 64.9058L236.805 65.0887C236.53 65.1176 236.284 64.9184 236.255 64.6437Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M229.294 65.3762C229.266 65.1015 229.465 64.8555 229.739 64.8266L233.718 64.4085C233.992 64.3797 234.238 64.5789 234.267 64.8535C234.296 65.1282 234.097 65.3742 233.822 65.4031L231.833 65.6121L231.211 65.6774L229.844 65.8212C229.569 65.85 229.323 65.6508 229.294 65.3762Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M223.328 66.0031C223.299 65.7285 223.498 65.4825 223.773 65.4536L226.756 65.14C227.031 65.1111 227.277 65.3104 227.306 65.585C227.335 65.8596 227.135 66.1057 226.861 66.1345L225.369 66.2913L224.872 66.3436L223.877 66.4481C223.603 66.477 223.357 66.2777 223.328 66.0031Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M218.355 66.5256C218.326 66.251 218.525 66.0049 218.8 65.9761L220.789 65.767C221.064 65.7381 221.31 65.9374 221.339 66.212C221.367 66.4866 221.168 66.7327 220.894 66.7615L219.899 66.866L219.526 66.9052L218.905 66.9706C218.63 66.9994 218.384 66.8002 218.355 66.5256Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M214.376 66.9436C214.348 66.6689 214.547 66.4229 214.821 66.394L215.816 66.2895C216.091 66.2606 216.337 66.4599 216.366 66.7345C216.394 67.0091 216.195 67.2552 215.921 67.284L215.423 67.3363L215.175 67.3624L214.926 67.3885C214.651 67.4174 214.405 67.2182 214.376 66.9436Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.392 67.257C211.363 66.9824 211.562 66.7364 211.837 66.7075L212.832 66.603C213.106 66.5741 213.352 66.7733 213.381 67.048C213.41 67.3226 213.211 67.5686 212.936 67.5975L212.439 67.6498L212.19 67.6759L211.942 67.702C211.667 67.7309 211.421 67.5317 211.392 67.257Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.097 61.6125C265.068 61.3379 265.268 61.0918 265.542 61.063L266.537 60.9584C266.811 60.9296 267.057 61.1288 267.086 61.4034C267.115 61.6781 266.916 61.9241 266.641 61.953L266.144 62.0052L265.895 62.0314L265.647 62.0575C265.372 62.0864 265.126 61.8871 265.097 61.6125Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M262.113 61.9269C262.084 61.6523 262.283 61.4063 262.558 61.3774L263.552 61.2729C263.827 61.244 264.073 61.4433 264.102 61.7179C264.131 61.9925 263.931 62.2386 263.657 62.2674L263.16 62.3197L262.911 62.3458L262.662 62.3719C262.388 62.4008 262.142 62.2016 262.113 61.9269Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M257.14 62.4494C257.111 62.1748 257.311 61.9287 257.585 61.8999L259.574 61.6908C259.849 61.662 260.095 61.8612 260.124 62.1358C260.153 62.4105 259.953 62.6565 259.679 62.6853L258.684 62.7899L258.311 62.8291L257.69 62.8944C257.415 62.9233 257.169 62.724 257.14 62.4494Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M251.173 63.0764C251.144 62.8017 251.344 62.5557 251.618 62.5268L254.602 62.2133C254.877 62.1844 255.123 62.3836 255.151 62.6582C255.18 62.9329 254.981 63.1789 254.706 63.2078L253.215 63.3646L252.717 63.4168L251.723 63.5214C251.448 63.5502 251.202 63.351 251.173 63.0764Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M244.212 63.8078C244.184 63.5332 244.383 63.2871 244.657 63.2583L248.636 62.8402C248.91 62.8113 249.156 63.0105 249.185 63.2852C249.214 63.5598 249.015 63.8058 248.74 63.8347L246.751 64.0437L246.129 64.1091L244.762 64.2528C244.487 64.2817 244.241 64.0824 244.212 63.8078Z",
    fill: "#F2F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.492 48.494C221.626 40.2551 227.603 32.8742 235.842 32.0082C244.081 31.1423 251.461 37.1193 252.327 45.3581L222.492 48.494Z",
    fill: "#B8B5EF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_246_137259)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.258 26.6856C236.834 26.282 237.179 25.5865 237.1 24.8379C236.985 23.7394 236.001 22.9424 234.902 23.0579C233.804 23.1733 233.007 24.1575 233.122 25.256C233.201 26.0056 233.684 26.6148 234.332 26.8894C234.32 26.9708 234.318 27.055 234.327 27.1406C234.438 28.1985 234.552 29.2816 234.657 30.2843L234.663 30.3367C234.731 30.9835 234.795 31.596 234.853 32.1455C227.148 33.4709 221.685 40.5583 222.487 48.4429C222.347 47.3714 221.376 46.6014 220.295 46.715L218.306 46.9241C217.208 47.0396 216.411 48.0237 216.526 49.1222L222.493 48.495L222.493 48.4943L252.328 45.3585C251.498 37.4543 244.67 31.632 236.842 31.9366C236.781 31.3568 236.715 30.7274 236.645 30.0637C236.541 29.0785 236.43 28.0179 236.316 26.9323C236.307 26.846 236.287 26.7633 236.258 26.6856ZM252.329 45.3585C252.214 44.26 253.011 43.2759 254.109 43.1604L256.098 42.9514C257.197 42.8359 258.181 43.6328 258.296 44.7314L252.329 45.3585Z",
    fill: "#B8B5EF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_246_137259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.042 43.8891C227.984 43.3398 228.383 42.8477 228.932 42.79L233.909 42.2669C234.458 42.2092 234.95 42.6077 235.008 43.1569C235.065 43.7062 234.667 44.1983 234.118 44.256L231.629 44.5175L230.759 44.609L229.141 44.779C228.592 44.8368 228.1 44.4383 228.042 43.8891Z",
    fill: "#F2F1FC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_246_137259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.983 42.7396C238.926 42.1904 239.324 41.6983 239.873 41.6406L244.845 41.1181C245.394 41.0604 245.886 41.4588 245.944 42.0081C246.001 42.5573 245.603 43.0494 245.054 43.1071L243.438 43.2769L242.568 43.3684L240.082 43.6296C239.533 43.6874 239.041 43.2889 238.983 42.7396Z",
    fill: "#F2F1FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.265 19.6457C213.824 12.9685 219.049 7.63082 225.713 6.93041C226.163 6.88311 226.409 7.44117 226.07 7.74126L223.558 9.96734C219.582 13.489 216.559 17.9561 214.768 22.9557L214.141 24.7074C213.881 25.4329 212.8 25.1983 212.864 24.4304L213.265 19.6457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M213.919 74.3296C215.232 72.2295 217.443 70.8557 219.907 70.6093L260.978 66.5022C264.046 66.1954 267.018 67.6791 268.616 70.3161L358.639 218.854C361.87 224.185 358.031 231 351.797 231H130.434C124.15 231 120.32 224.088 123.65 218.76L213.919 74.3296Z",
    fill: "url(#paint0_linear_246_137259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.255 152.866C241.255 152.866 243.245 152.849 247.225 152.816C251.204 152.783 256.177 153.547 262.141 155.107C268.096 156.478 274.234 159.449 280.556 164.018C286.868 168.399 292.357 175.003 297.021 183.831C301.874 192.647 305.001 204.496 306.401 219.375C308.475 242.926 307.907 261.607 304.697 275.418C301.476 289.041 295.677 298.926 287.299 305.075C278.91 311.034 268.006 314.388 254.586 315.138C234.551 316.257 218.573 310.239 206.651 297.084C194.719 283.74 187.91 261.968 186.223 231.768C185.379 216.669 186.29 204.122 188.955 194.128C191.62 184.133 195.54 176.246 200.716 170.466C205.891 164.687 211.912 160.469 218.779 157.813C225.825 154.958 233.316 153.309 241.255 152.866ZM244.505 175.404C243.203 175.856 241.717 176.412 240.048 177.073C238.567 177.724 237.155 179.601 235.812 182.706C234.657 185.8 233.714 190.964 232.98 198.2C232.436 205.425 232.349 215.749 232.72 229.171C233.196 244.48 234.154 256.544 235.595 265.363C237.025 273.992 238.79 280.142 240.891 283.811C243.171 287.281 245.733 289.031 248.579 289.061C250.858 289.124 252.905 288.441 254.721 287.014C256.727 285.577 258.369 282.74 259.649 278.503C261.119 274.255 262.005 268.053 262.307 259.894C262.799 251.725 262.67 240.941 261.922 227.54C261.173 214.139 259.842 203.894 257.93 196.806C256.195 189.519 254.204 184.424 251.956 181.52C249.887 178.417 248.081 176.624 246.537 176.143C245.182 175.65 244.505 175.404 244.505 175.404Z",
    fill: "#FF64E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.732 179.004C200.05 186.608 199.998 194.816 200.058 196.737C200.067 197.021 200.083 197.298 200.094 197.582C200.165 199.347 204.114 199.566 204.499 197.842C205.308 194.22 206.28 190.596 207.437 187.334C214.006 168.804 226.378 171.225 225.481 168.472C223.796 163.299 214.979 166.879 211.211 170.804C210.455 171.591 209.726 172.369 209.087 173.081C207.462 174.891 206.008 176.932 204.732 179.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.179 285.685C272.867 280.073 272.209 274.432 271.987 273.031C271.951 272.808 271.91 272.59 271.871 272.368C271.647 271.059 268.685 271.263 268.544 272.583C268.266 275.191 267.866 277.812 267.297 280.193C264.048 293.784 254.544 292.99 255.467 294.87C257.286 298.576 263.55 295.165 266.137 291.948C266.52 291.472 266.889 291.003 267.222 290.565C268.365 289.063 269.363 287.387 270.179 285.685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6281 208.872C45.6281 208.872 45.5208 208.142 45.3063 206.684C45.2494 205.184 45.4663 203.444 45.957 201.463C46.5639 199.284 47.9625 197.233 50.1529 195.312C52.3019 193.233 55.6818 191.672 60.2926 190.63C66.4791 189.174 70.9233 189.102 73.6253 190.412C76.4849 191.682 78.2622 193.319 78.9572 195.325C79.6108 197.174 80.041 198.491 80.2477 199.279C80.3717 199.751 80.7555 202.175 81.3989 206.551C82.1586 210.729 83.0088 215.892 83.9494 222.042C84.8487 228.034 85.6692 234.046 86.411 240.08C87.3103 246.072 88.0403 251.099 88.6011 255.16C89.3194 259.179 89.6786 261.189 89.6786 261.189L111.462 253.703L98.7308 213.869C98.7308 213.869 98.5861 213.318 98.2968 212.215C98.1649 211.072 98.3857 209.667 98.9591 208.002C99.6486 206.137 101.089 204.244 103.279 202.323C105.469 200.401 108.965 198.642 113.767 197.044C118.569 195.447 122.533 194.827 125.659 195.185C128.784 195.543 131.263 196.323 133.094 197.526C134.884 198.571 136.102 199.682 136.748 200.859C137.552 201.995 137.953 202.563 137.953 202.563L167.225 293.856C167.225 293.856 167.332 294.586 167.546 296.044C167.877 297.304 167.739 299.024 167.132 301.203C166.641 303.184 165.243 305.234 162.936 307.354C160.588 309.317 156.814 310.981 151.615 312.346C146.415 313.711 142.232 314.136 139.065 313.621C135.898 313.106 133.457 312.147 131.741 310.746C130.184 309.303 129.082 307.993 128.436 306.816C127.948 305.598 127.704 304.989 127.704 304.989L117.74 273.77L88.417 285.255C88.417 285.255 87.1978 285.743 84.7594 286.72C82.2796 287.539 79.3233 288.147 75.8903 288.543C72.615 288.898 69.448 288.383 66.3895 286.997C63.4886 285.571 61.5382 282.632 60.5382 278.181C58.5384 269.28 56.2452 258.94 53.6588 247.163C51.1886 235.187 48.5117 222.423 45.6281 208.872Z",
    fill: "#7974E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.199 219.27C52.489 220.864 53.1218 224.346 53.754 227.845C53.906 228.686 55.6509 228.588 55.7469 227.739C56.0192 225.332 56.3345 222.924 56.544 220.432C56.9065 216.122 57.2611 211.613 56.6983 207.281C56.4192 205.133 56.2253 202.104 54.2831 200.828C52.421 199.605 50.0046 201.848 49.8286 204.069C49.7985 204.45 49.7977 204.792 49.8427 205.053C50.4383 208.524 51.5019 215.074 51.8891 217.466C51.9868 218.07 52.0895 218.669 52.199 219.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.502 227.605C111.132 229.097 112.508 232.358 113.886 235.635C114.218 236.422 115.9 235.947 115.808 235.097C115.55 232.689 115.334 230.27 114.996 227.793C114.411 223.507 113.775 219.028 112.283 214.923C111.543 212.887 110.694 209.973 108.521 209.151C106.437 208.362 104.567 211.078 104.879 213.284C104.932 213.662 105.006 213.996 105.107 214.242C106.444 217.499 108.908 223.661 109.807 225.911C110.034 226.48 110.264 227.041 110.502 227.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.504 166.391C378.504 166.391 378.904 165.691 379.706 164.291C380.671 162.962 382.035 161.611 383.796 160.238C385.792 158.773 388.382 157.954 391.566 157.781C394.821 157.445 398.785 158.387 403.457 160.608C409.765 163.538 413.639 166.48 415.078 169.435C416.681 172.461 417.103 175.072 416.345 177.268C415.658 179.3 415.137 180.725 414.783 181.543C414.57 182.033 413.261 184.379 410.856 188.58C408.686 192.688 405.926 197.706 402.578 203.635C399.301 209.399 395.941 215.129 392.5 220.822C389.223 226.587 386.453 231.407 384.19 235.281C382.09 239.225 381.04 241.198 381.04 241.198L404.847 249.484L420.824 206.595C420.824 206.595 421.072 206.023 421.569 204.879C422.229 203.805 423.368 202.746 424.988 201.7C426.842 200.562 429.361 199.907 432.545 199.734C435.729 199.561 439.927 200.411 445.14 202.283C450.352 204.155 454.182 206.302 456.63 208.723C459.078 211.144 460.684 213.491 461.447 215.764C462.281 217.874 462.578 219.654 462.338 221.103C462.261 222.624 462.223 223.384 462.223 223.384L425.688 321.741C425.688 321.741 425.287 322.441 424.486 323.841C423.918 325.149 422.637 326.535 420.641 328C418.88 329.373 416.29 330.192 412.871 330.457C409.524 330.559 405.151 329.44 399.753 327.099C394.355 324.758 390.468 322.295 388.091 319.71C385.714 317.126 384.261 314.65 383.733 312.285C383.367 309.99 383.305 308.118 383.545 306.668C383.949 305.289 384.15 304.6 384.15 304.6L396.683 270.997L363.683 261.055C363.683 261.055 362.304 260.651 359.545 259.843C356.857 258.872 353.902 257.396 350.68 255.416C347.621 253.507 345.244 250.922 343.549 247.662C342.017 244.473 342.325 240.625 344.474 236.119C348.771 227.106 353.789 216.658 359.526 204.774C365.497 192.797 371.823 180.003 378.504 166.391Z",
    fill: "#7974E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.103 185.154C372.826 185.711 372.366 186.636 371.785 187.802C369.634 192.121 372.06 193.724 374.971 189.876C378.393 185.352 381.957 180.603 384.76 175.434C386.15 172.871 388.247 169.391 387.854 166.675C387.555 164.612 384.414 164.834 383.076 166.433C382.494 167.129 381.968 167.829 381.696 168.366C379.407 172.886 374.902 181.641 373.698 183.98C373.494 184.375 373.301 184.757 373.103 185.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.912 230.295C420.801 230.908 420.617 231.924 420.385 233.206C419.524 237.954 422.301 238.816 424.023 234.309C426.047 229.01 428.143 223.455 429.393 217.709C430.012 214.859 431.055 210.933 429.919 208.434C429.057 206.536 426.102 207.626 425.264 209.535C424.899 210.365 424.589 211.185 424.478 211.776C423.541 216.756 421.658 226.42 421.155 229.002C421.07 229.438 420.991 229.858 420.912 230.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter5_f_246_137259)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 241,
    cy: 359,
    rx: 120,
    ry: 8,
    fill: "#7974E0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.545 156.463L131.618 161.701",
    stroke: "#7974E0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.701 160.546L130.463 157.619",
    stroke: "#7974E0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5449 66.4629L93.6182 71.7007",
    stroke: "#7974E0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7007 70.5459L92.4629 67.6191",
    stroke: "#7974E0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.545 75.4629L328.618 80.7007",
    stroke: "#B8B5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.701 79.5459L327.463 76.6191",
    stroke: "#B8B5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.684 93.5605L153.562 96.6869",
    stroke: "#B8B5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.687 97.6846L154.561 92.5635",
    stroke: "#B8B5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.238 145.988L342.261 146.511",
    stroke: "#B8B5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.511 149.238L344.988 143.261",
    stroke: "#B8B5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.648 98.8369L387.974 100.788",
    stroke: "#7974E0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.787 102.65L389.836 96.9756",
    stroke: "#7974E0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3398 138.755L65.3908 137.974",
    stroke: "#B8B5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9754 141.339L68.7559 135.39",
    stroke: "#B8B5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_246_137259",
    x: 168.812,
    y: 44.0381,
    width: 139.26,
    height: 22.1504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.833745 0 0 0 0 0.828679 0 0 0 0 0.975589 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_246_137259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_246_137259",
    x: 168.84,
    y: 49.5547,
    width: 139.262,
    height: 22.1504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.635607 0 0 0 0 0.619295 0 0 0 0 0.934653 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_246_137259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_246_137259",
    x: 216.516,
    y: 21.0469,
    width: 41.7812,
    height: 28.0752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.635294 0 0 0 0 0.933333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_246_137259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_246_137259",
    x: 224.037,
    y: 38.2617,
    width: 14.9766,
    height: 10.5225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_246_137259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_246_137259",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_246_137259",
    x: 234.979,
    y: 37.1123,
    width: 14.9707,
    height: 10.5225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_246_137259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_246_137259",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_246_137259",
    x: 111,
    y: 341,
    width: 260,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_246_137259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_137259",
    x1: 241,
    y1: 69,
    x2: 241,
    y2: 201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B5EF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_137259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481,
    height: 383,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Illustration);
export default __webpack_public_path__ + "static/media/404-illustration.ca3c55b8f8525a99eed40628a870867d.svg";
export { ForwardRef as ReactComponent };